import $ from 'jquery';

$('.control-input').each(function () {
    if ($(this).val() === '') {
        $(this).addClass('placeholder-shown');
        $(this).next('.control-input-placeholder').addClass('control-input-placeholder--active');
    } else {
        $(this).removeClass('placeholder-shown');
        $(this).next('.control-input-placeholder').removeClass('control-input-placeholder--active');
    }
});

$('.control-input').keydown(function () {
    $(this).removeClass('placeholder-shown');
    $(this).next('.control-input-placeholder').removeClass('control-input-placeholder--active');
});

$('.control-input').keyup(function () {
    if ($(this).val() === '') {
        $(this).addClass('placeholder-shown');
        $(this).next('.control-input-placeholder').addClass('control-input-placeholder--active');
    } else {
        $(this).next('.control-input-placeholder').removeClass('control-input-placeholder--active');
    }
});
